import Raven from "raven-js";

function configureRaven() {
  let env = gon.env;
  let envVars = gon.env_vars;

  if (env !== "test") {
    installRaven(env, envVars)
  }
}

function installRaven (env, envVars) {
  let config = {
    release:      envVars.version,
    environment:  env,
    ignoreUrls: [
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
      /^ms-browser-extension:\/\//i,
    ],
  }

  Raven.config(envVars.sentry_dsn, config).install();
}

export default configureRaven;
